import { InjectionToken } from '@angular/core';
import { InitialNavigation } from '@angular/router';
import { IEnvironment } from "@environments/IEnvironment";

export const ENVIRONMENTER = new InjectionToken("Environmenter");
export const USER_AGENT = new InjectionToken<string>("USER_AGENT");
export const CLIENT_COOKIES = new InjectionToken<Record<string, string>>("CLIENT_COOKIES");
export const SERVER_ENV = new InjectionToken<IEnvironment>("SERVER_ENV");

export const INITIAL_NAVIGATION = new InjectionToken<InitialNavigation>(
    "",
    { providedIn: 'root', factory: () => "enabledBlocking" });

